import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
export default function Toaster() {
  return (
    <ToastContainer position={toast.POSITION.BOTTOM_RIGHT} autoClose={5000} />
  );
}



// WEBPACK FOOTER //
// ./src/components/Common/Toaster.js